<template>
  <v-row row wrap>
    <v-col>
      <v-btn-toggle color="primary" v-model="selected" class="mb-5">
        <v-btn :value="types.country" x-small>
          Country
        </v-btn>
        <v-btn :value="types.region" x-small>
          Region
        </v-btn>
        <v-btn v-if="isCountyPulseUnlocked" :value="types.county" x-small>
          US County
        </v-btn>
        <v-btn :value="types.city" x-small>
          City
        </v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>

<script>
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";

import {
  GET_STABILITY_PARAMS,
  SAVE_PREFERENCES,
  GET_STABILITY_REFRESH_MAP,
  GET_POWER_OUTAGE_REFRESH_MAP,
  GET_SELECTOR_PANEL,
} from "@/store/actions.type";
import {
  MODULE_PREFIX_GRIDS,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_POWER_OUTAGE,
  MODULE_PREFIX_HOME,
} from "@/store";
import { buildPreferences } from "@/services/grids/stability.service";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";

export default {
  name: "StabilityTypeBar",
  data: () => ({
    selected: null,
  }),
  mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      stability: MODULE_PREFIX_GRIDS + "stability",
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
    isCountyPulseUnlocked() {
      return this.featureUnlocked("pulse-counties");
    },
    types() {
      return GRIDS_STABILITY_TYPES;
    },
  },
  methods: {
    toggleType() {
      const PREF_PARAMS = buildPreferences({
        preferences: this.preferences,
        type: this.selected || null,
      });

      // if a stability type is set then need to make sure powerOutage is off
      if (this.selected) {
        PREF_PARAMS.powerOutage = PREF_PARAMS.powerOutage || {};
        PREF_PARAMS.powerOutage.enabled = false;
        const selectorPanel = this.selectorPanel;
        selectorPanel.powerOutage = false;
        this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
          selectorPanel
        );
        this.$store.dispatch(
          MODULE_PREFIX_POWER_OUTAGE + GET_POWER_OUTAGE_REFRESH_MAP,
          true
        );
      }

      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, PREF_PARAMS);

      let params = this.stability.params;
      params.type = this.selected;
      this.$store.dispatch(MODULE_PREFIX_GRIDS + GET_STABILITY_PARAMS, params);
      this.$store.dispatch(
        MODULE_PREFIX_GRIDS + GET_STABILITY_REFRESH_MAP,
        true
      );
    },
    getPrefs() {
      if (lodashGet(this.preferences, "grids.stability.type")) {
        this.selected = this.preferences.grids.stability.type;
      }
    },
  },
  watch: {
    selected() {
      this.toggleType();
    },
    "stability.params": {
      handler() {
        if (this.stability.params) {
          this.selected = this.stability.params.type;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.hyp-stability-type-bar-btn {
  width: 58px;
  height: 74px;
  cursor: pointer;
}
.hyp-stability-type-bar-btn-active {
  border: 1px solid rgba(0, 174, 66, 0.41) !important;
  box-shadow: 0 2px 11px 0 rgba(0, 174, 66, 0.23) !important;
  border-radius: 9px !important;
  background-color: white !important;
}
.hyp-stability-type-bar-img {
  margin: 9px 9px 0 11px;
}
.hyp-stability-type-bar-img-md {
  margin-top: 20px;
}
.hyp-stability-type-bar-img-sm {
  margin-top: 29px;
}
.hyp-stability-type-bar-text {
  color: #1e1e1e;
  font-size: 12px;
}
.hyp-stability-type-bar-text-active {
  color: $primary-color !important;
}
</style>
